[
  {
    "code": "MR-07",
    "name": "Adrar"
  },
  {
    "code": "MR-03",
    "name": "Assaba"
  },
  {
    "code": "MR-05",
    "name": "Brakna"
  },
  {
    "code": "MR-08",
    "name": "Dakhlet Nouâdhibou"
  },
  {
    "code": "MR-04",
    "name": "Gorgol"
  },
  {
    "code": "MR-10",
    "name": "Guidimaka"
  },
  {
    "code": "MR-01",
    "name": "Hodh ech Chargui"
  },
  {
    "code": "MR-02",
    "name": "Hodh el Gharbi"
  },
  {
    "code": "MR-12",
    "name": "Inchiri"
  },
  {
    "code": "MR-NKC",
    "name": "Nouakchott"
  },
  {
    "code": "MR-09",
    "name": "Tagant"
  },
  {
    "code": "MR-11",
    "name": "Tiris Zemmour"
  },
  {
    "code": "MR-06",
    "name": "Trarza"
  }
]